import script from "./supplier.vue?vue&type=script&setup=true&lang=js"
export * from "./supplier.vue?vue&type=script&setup=true&lang=js"

import "./supplier.vue?vue&type=style&index=0&id=480bef4a&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-480bef4a"]])

export default __exports__